import { API } from "aws-amplify";

export type EdgeDeviceStatus = {
  iotThingName: string;
  status: string;
  timestamp: number;
}

export async function listEdgeDeviceStatus(iotThingName: string): Promise<EdgeDeviceStatus[]> {
  try {
    const path: string = `/devices/status-changes/${iotThingName}`
    const data = await API.get('api-service', path, {});

    return data.data;

  } catch (error) {
    console.log(error);
    throw error;
  }
}